<template>
    <div id="home">
        <div v-if="state.genres_loaded" class="container-fluid">
            <h2>Жанры</h2>
            <ul class="lp-large">
                <li v-for="g in state.genres"  class="orchestra_item">
                    <router-link class="orchestra" :to="'/genres/' + g.id">{{ g.name }}</router-link> ({{ g.recordings }})
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { tdj2 } from '@/tdj2.js'

import axios from 'axios'

export default {
  name: 'genres',

  created () {
  },

  data () {
    return {
      state: tdj2.state,
    }
  },

  components: {
  }
}
</script>

<style lang="less">

</style>
